export enum Roles {
    VOLUNTEER = 'VOLUNTEER',
    EMPLOYER = 'EMPLOYER'
}